export default function() {
    let config = angular.copy(window.config);
    delete window.config;

    angular.extend(this, config, {
        $get: function() {
            return config;
        }
    });
}



// WEBPACK FOOTER //
// ./config/config-provider.js